import request from '@/utils/request';
/**
 * 统一认证登录
 */
// 登录，先获取code值
export function userLoginCode(query) {
  return request({
    url: '/auth/local/login',
    method: 'get',
    ...query
  });
}
// 登录，获取统一认证链接
export function userLogin(query) {
  return request({
    url: '/auth/sso/login',
    method: 'get',
    ...query
  });
}
// 登出
export function userLogout(query) {
  return request({
    url: '/auth/sso/logout',
    method: 'get',
    ...query
  });
}
// 获取token
export function userK2Token(code) {
  return request({
    url: 'auth/getTokenByCode?code=' + code,
    method: 'get'
  });
}
// 刷新token
// export function refreshAccessToken(bip: string) {
//   return request({
//     url: '/auth/getAccessRefreshToken?bip=' + bip,
//     method: 'get'
//   })
// }